import { EmailStatusPage } from "./EmailStatusPage";
export default EmailStatusPage;
export * from "./EmailStatusPage";
